/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Keyword_OtherInputs */

const en_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} keywords`)
};

const zh_hans1_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个关键词`)
};

const pt_br2_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} palavras-chave`)
};

const es_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} palabras clave`)
};

const fr_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mots-clés`)
};

const de_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Keywords`)
};

const ru_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ключевых слов: ${i?.count}`)
};

const it_measure_unit_keyword_other = /** @type {(inputs: Measure_Unit_Keyword_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parole chiave`)
};

/**
* | output |
* | --- |
* | "{count} keywords" |
*
* @param {Measure_Unit_Keyword_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_keyword_other = /** @type {((inputs: Measure_Unit_Keyword_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Keyword_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_keyword_other(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_keyword_other(inputs)
	if (locale === "es") return es_measure_unit_keyword_other(inputs)
	if (locale === "fr") return fr_measure_unit_keyword_other(inputs)
	if (locale === "de") return de_measure_unit_keyword_other(inputs)
	if (locale === "ru") return ru_measure_unit_keyword_other(inputs)
	if (locale === "it") return it_measure_unit_keyword_other(inputs)
	return en_measure_unit_keyword_other(inputs)
});